import {
  ArrowUpDown, Columns2, DoorOpen, Ear, Footprints, Layers, LayoutGrid, Lock, MoveHorizontal, Paintbrush, Palette,
  Scale, ShieldCheck, Sparkles, Sun, Thermometer, Moon, Zap, Wind, Droplets, Home,
} from "lucide-react";

export const ICONS = {
  ArrowUpDown, Columns2, DoorOpen, Ear, Footprints, Layers, LayoutGrid, Lock, MoveHorizontal, Paintbrush, Palette,
  Scale, ShieldCheck, Sparkles, Sun, Thermometer, Moon, Zap, Wind, Droplets, Home,
};
